import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import DatePicker from 'react-datepicker/es';
import FormError from '../_shared/forms/FormError';
import SubmitButton from '../_shared/SubmitButton';
import { snakeCaseToTitle } from '../../utils/Helpers';
import axios from 'axios';
import FormSelect from 'react-select';

export default class WasteTippingFilter extends Component {
    constructor(props) {
        super(props);

        const export_types = [
            { label: 'Customers', value: 'customers' },
            { label: 'Providers', value: 'providers' },
        ];
        this.state = {
            date_from: '',
            date_to: '',
            export_types: export_types,
            export_type: export_types[0],
            loading: false,
            notFound: false,
            errors: {},
        };
    }

    handleDateChange = (date, property) => {
        this.setState({
            [property]: date,
        });
    };

    validateForm = () => {
        let errors = {};
        const fields = ['date_from', 'date_to'];

        fields.map((field) => {
            if (!this.state[field]) {
                errors[field] = `${snakeCaseToTitle(field).replace('id', '')} field is required`;
            }
        });

        this.setState({ errors: errors });

        if (Object.keys(errors).length > 0) {
            toastr.error('Please fill in all required fields');
        }

        return Object.keys(errors).length === 0;
    };

    onSubmit = (e) => {
        e.preventDefault();

        this.setState({
            notFound: false,
        });

        if (this.validateForm()) {
            this.setState({
                loading: true,
            });

            const date_from = moment(this.state.date_from).format('YYYY-MM-DD');
            const date_to = moment(this.state.date_to).format('YYYY-MM-DD');

            const file_name = 'waste-tipping-' + date_from + '-to-' + date_to + '.xlsx';
            axios({
                url: this.props.url,
                method: 'GET',
                responseType: 'blob',
                params: {
                    date_from: date_from,
                    date_to: date_to,
                    export_type: this.state.export_type.value,
                },
            })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', file_name); //or any other extension
                    document.body.appendChild(link);
                    link.click();

                    this.setState({
                        loading: false,
                    });
                })
                .catch((error) => {
                    this.setState({
                        notFound: true,
                        loading: false,
                    });
                });
        }
    };

    handleFilterChange = (e) => {
        this.setState({
            export_type: e,
        });
    };

    render() {
        return (
            <form onSubmit={this.onSubmit}>
                <div className="row">
                    <div className="col-md-12">
                        <h4 className="text-center">Filter Waste Tippings</h4>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4 form-group">
                        <DatePicker
                            className="form-control"
                            placeholderText="Date from..."
                            onChange={(date) => this.handleDateChange(date, 'date_from')}
                            selected={this.state.date_from}
                            dateFormat="dd/MM/yyyy"
                            isClearable
                        />
                        <FormError error={this.state.errors.date_from} />
                    </div>
                    <div className="col-md-4 form-group">
                        <DatePicker
                            className="form-control"
                            placeholderText="Date to..."
                            onChange={(date) => this.handleDateChange(date, 'date_to')}
                            selected={this.state.date_to}
                            dateFormat="dd/MM/yyyy"
                            isClearable
                        />
                        <FormError error={this.state.errors.date_to} />
                    </div>
                    <div className="col-md-4 form-group">
                        <FormSelect
                            label="Customer Type"
                            name="customer_type"
                            classes={'form-control'}
                            value={this.state.export_type}
                            onChange={this.handleFilterChange}
                            options={this.state.export_types}
                        />
                    </div>
                    <div className="col-md-4 form-group">
                        <SubmitButton buttonText={'Download'} loading={this.state.loading} style={{ width: 200 }} />
                    </div>
                </div>
                {this.state.notFound ? (
                    <div className="row">
                        <div className="col-md-12">
                            <p className="text-danger text-center">No waste tipping found</p>
                        </div>
                    </div>
                ) : (
                    ''
                )}
            </form>
        );
    }
}

if (document.getElementById('waste-tipping-filter')) {
    let element = document.getElementById('waste-tipping-filter');

    ReactDOM.render(<WasteTippingFilter url={element.dataset.url} />, element);
}
